/*
* 项目分享相关（现阶段只有微信分享调用了）
* */
import store from '@store';
import router from '@router';
import $Axios from '$axios';
import { $toast } from '$use-in-vue/mint-ui/toast';

//项目分享
export function shareSuccess() {
  //分享添加积分
  shareAddAccumulatePoints();
}

//分享添加积分
export function shareAddAccumulatePoints() {
  //针对项目的指定路径分享，可以获得积分值

    $Axios({
      method: 'post',
      url: '/api/share/index',
      isLoading: false,
      params: {
        url: router.currentRoute.fullPath
      }
    }).then((res) => {
      const { data } = res.data;
      if (res.data.code == 13333) {
        store.state.shareState = true;
      }else{
        if (data.integral > 0) {
          $toast({
            message: `分享成功 +${data.integral}学分`
          });
        }else{
          $toast({
            message: `分享成功`
          });
        }
      }
    });
}